import { render, staticRenderFns } from "./AgentDetail.vue?vue&type=template&id=8595118c&scoped=true&"
import script from "./AgentDetail.vue?vue&type=script&lang=js&"
export * from "./AgentDetail.vue?vue&type=script&lang=js&"
import style0 from "./AgentDetail.vue?vue&type=style&index=0&id=8595118c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8595118c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VIcon,
  VLayout,
  VList,
  VListTile,
  VMenu,
  VSpacer,
  VTooltip,
})
